const status = [
  {id: 'request', name: '발급요청'},
  {id: 'done', name: '발급완료'}
]

export {status}
